import React, { useState } from 'react';
import { PrivacyPolicyModal } from './modals/PrivacyPolicyModal';
import { TermsOfServiceModal } from './modals/TermsOfServiceModal';
export const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-white border-t border-[#E5C1A9] py-6" data-id="element-429">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-430">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0" data-id="element-431">
            <div className="flex flex-wrap justify-center gap-6" data-id="element-432">
              <button onClick={() => setShowPrivacy(true)} className="text-sm text-[#6B4B3E]/75 hover:text-[#6B4B3E] transition-colors" data-id="element-433">
                Privacy Policy
              </button>
              <button onClick={() => setShowTerms(true)} className="text-sm text-[#6B4B3E]/75 hover:text-[#6B4B3E] transition-colors" data-id="element-434">
                Terms of Service
              </button>
              <span className="text-sm text-[#6B4B3E]/75" data-id="element-435">
                grace@storybunny.ai
              </span>
              <span className="text-sm text-[#6B4B3E]/75" data-id="element-436">@storybunny.ai</span>
            </div>
          </div>
        </div>
      </footer>
      {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} data-id="element-437" />}
      {showTerms && <TermsOfServiceModal onClose={() => setShowTerms(false)} data-id="element-438" />}
    </>;
};